import React, { useState } from 'react';
import LinkButton from './LinkButton';
import RemoveConfirmationModal from '../RemoveConfirmation/RemoveConfirmationModal';
import useNotification from '../../Hooks/useNotification.hook';
import { Theme } from '../../Enums/Theme.enum';

interface RemoveButtonProps {
	onClick: () => void;
	title?: string;
	flashMessage?: string;
	confirmationText?: string;
	confirmationTitle?: string;
	showAbort?: boolean;
	customButtons?: () => React.ReactNode | React.ReactNode[];
	showConfirmation?: boolean;
	firstUpper?: boolean;
	buttonClassName?: string;
	confirmationNote?: string;
}

export default function RemoveButton(props: RemoveButtonProps) {
	const {
		onClick,
		flashMessage = 'base.deleted',
		title = 'base.shared.delete',
		showAbort,
		confirmationText,
		confirmationTitle,
		customButtons,
		showConfirmation = true,
		firstUpper = false,
		buttonClassName,
		confirmationNote,
	} = props;
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const { showNotificationSuccess, showNotificationAlert } = useNotification();

	const handlePress = () => {
		setConfirmationOpen(true);
	};

	const handleConfirm = () => {
		onClick?.();
		if (showConfirmation) {
			showNotificationSuccess({
				content: flashMessage,
			});
		}
		setConfirmationOpen(false);
	};

	return (
		<>
			<LinkButton
				onClick={handlePress}
				title={title}
				theme={Theme.RED}
				firstUpper={firstUpper}
				className={buttonClassName}
			/>
			{confirmationOpen && (
				<RemoveConfirmationModal
					opened
					onClose={() => setConfirmationOpen(false)}
					onConfirm={handleConfirm}
					confirmationText={confirmationText}
					confirmationTitle={confirmationTitle}
					customButtons={customButtons}
					showAbort={showAbort}
					confirmationNote={confirmationNote}
				/>
			)}
		</>
	);
}
